import { takeEvery, put, call, fork } from "redux-saga/effects";
import { getCasesForAStage } from "services/case-service";
import {
    fetchedStageCase,
    failedFetchStageCase
    // fetchedCasesCount,
    // failedFetchCasesCount
} from "actions";
import { STAGE_CASE_ACTIONS } from "constants";
import { message } from "antd";

function* caseFetchHandler({ payload }) {
    try {
        const { data, error } = yield call(
            getCasesForAStage,
            payload.type,
            payload.stageId,
            payload.page,
            payload.pageSize,
            payload.filters,
            payload.documentFilter
        );
        if (!error) {
            yield put(
                fetchedStageCase(
                    payload.type,
                    payload.stage,
                    payload.page,
                    data.results,
                    data.count,
                    payload.filters
                )
            );
        } else {
            yield put(
                failedFetchStageCase(
                    payload.type,
                    payload.stage,
                    error,
                    payload.filters
                )
            );
        }
    } catch (error) {
        message.error("Failed to fetch Cases");
        yield put(
            failedFetchStageCase(
                payload.type,
                payload.stage,
                error,
                payload.filters
            )
        );
    }
}

export default fork(function*() {
    yield takeEvery(STAGE_CASE_ACTIONS.FETCH_STAGE_CASE, caseFetchHandler);
});
